import { render, staticRenderFns } from "./component-download.vue?vue&type=template&id=a4c07f76&scoped=true&"
import script from "./component-download.vue?vue&type=script&lang=js&"
export * from "./component-download.vue?vue&type=script&lang=js&"
import style0 from "./component-download.vue?vue&type=style&index=0&id=a4c07f76&prod&lang=less&scoped=true&"
import style1 from "./component-download.vue?vue&type=style&index=1&id=a4c07f76&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4c07f76",
  null
  
)

export default component.exports